<template>
  <div class="modal-holder">
    <Transition name="bounce">
      <div class="modal-content" v-if="showModalContent">
        <div class="modal-row">
          <div class="heading">
            <h5>
              {{ paymentMethod ? 'Update' : 'Add New' }} Payment Method
              <span></span>
            </h5>
            <i class="bi bi-x-circle" @click="$emit('closeModal')"></i>
          </div>
        </div>
        <form @submit.prevent="submitPaymentMethod()">
          <div class="modal-row">
            <div class="row">
              <div class="col-sm-6">
                <label>Payment Method:</label>
                <select
                  class="form-select"
                  v-model="formValue.payment_method"
                  required
                >
                  <option value="bkash">bKash</option>
                  <option value="bank">bank</option>
                </select>
              </div>
              <div class="col-sm-6" v-if="formValue.payment_method === 'bkash'">
                <label>bKash Number:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.account_no"
                  required
                  maxlength="11"
                  pattern="[0-9]{11}"
                  title="11 digit length containing only numbers!"
                />
              </div>
            </div>
            <div class="row" v-if="formValue.payment_method === 'bank'">
              <div class="col-sm-6">
                <label for="">Bank Name:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.bank_name"
                  required
                />
              </div>
              <div class="col-sm-6">
                <label for="">Customer Name:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.customer_name"
                  required
                />
              </div>
            </div>
            <div class="row" v-if="formValue.payment_method === 'bank'">
              <div class="col-sm-6">
                <label for="">Routing No:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.routing_no"
                  required
                  max="30"
                />
              </div>
              <div class="col-sm-6">
                <label for="">Account Number:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.account_no"
                  required
                  max="30"
                />
              </div>
            </div>
          </div>
          <div class="modal-row" style="overflow: hidden">
            <div class="footer">
              <div class="buttons">
                <button
                  v-if="isLoading"
                  class="btn btn-primary"
                  type="button"
                  disabled
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
                <button v-else class="btn btn-primary">Submit</button>
                <button
                  class="btn btn-link"
                  type="button"
                  @click="$emit('closeModal')"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Transition>
  </div>
</template>
    
<script>
import http from '../../config/axios';
export default {
  props: [
    'userCode',
    'paymentMethod',
    'date',
    'tzoffset',
    'modality',
    'serviceType'
  ],
  data() {
    return {
      showModalContent: false,
      isLoading: false,
      formValue: {
        billing_trip_start_date: new Date(this.date[0] - this.tzoffset)
          .toISOString()
          .substring(0, 10),
        billing_trip_end_date: new Date(this.date[1] - this.tzoffset)
          .toISOString()
          .substring(0, 10),
        modality: this.modality ? this.modality : null,
        service_type: this.serviceType ? this.serviceType : null,
        user_code: '',
        payment_method: this.paymentMethod
          ? this.paymentMethod.payment_method
          : 'bkash',
        account_no: '',
        bank_name: '',
        routing_no: '',
        customer_name: ''
      }
    };
  },
  mounted() {
    this.showModalContent = true;
    this.setFormValues();
  },
  watch: {
    userCode() {
      this.setFormValues();
    },
    paymentMethod() {
      this.setFormValues();
    },
    'formValue.payment_method': function () {
      this.emptyFormValue();
    }
  },
  methods: {
    setFormValues() {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      this.formValue.user_code = this.userCode;
      this.formValue.billing_trip_start_date = startDate;
      this.formValue.billing_trip_end_date = endDate;
      this.formValue.modality = this.modality ? this.modality : null;
      this.formValue.service_type = this.serviceType ? this.serviceType : null;
      if (this.paymentMethod) {
        this.formValue = {
          billing_trip_start_date: startDate,
          billing_trip_end_date: endDate,
          modality: this.modality ? this.modality : null,
          service_type: this.serviceType ? this.serviceType : null,
          user_code: this.paymentMethod.user_code,
          payment_method: this.paymentMethod.payment_method,
          account_no: this.paymentMethod.account_no,
          bank_name: this.paymentMethod.bank_name,
          routing_no: this.paymentMethod.routing_no,
          customer_name: this.paymentMethod.customer_name
        };
      }
    },
    emptyFormValue() {
      this.formValue.account_no = '';
      this.formValue.bank_name = '';
      this.formValue.routing_no = '';
      this.formValue.customer_name = '';
    },
    submitPaymentMethod() {
      this.isLoading = true;
      let url = '/v2/partners/bills/update/payment/method';
      if (this.paymentMethod) {
        url += '/' + this.paymentMethod.id;
      }

      http
        .patch(url, this.formValue)
        .then((response) => {
          this.isLoading = false;
          this.$partnerSwal.quickSuccessAlert.fire({
            title: 'Success',
            text: response?.data?.message
          });
          this.emptyFormValue();
          this.$emit('refreshData');
          this.$emit('closeModal');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error?.response?.data?.message
          });
        });
    }
  }
};
</script>
    
<style scoped>
.modal-holder {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(18, 18, 18, 0.6);
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 0 20px;
  border-radius: 12px;
  max-height: 100%;
  overflow: auto;
}
.modal-row {
  padding: 16px 0;
  border-bottom: 0.5px solid #d5d5d5;
}
.modal-row:last-child {
  border-bottom: none;
}
h5,
h6,
ul {
  margin-bottom: 0;
}
.modal-row ul {
  padding-left: 0;
}
.modal-row ul li {
  list-style: none;
}

.heading h5 {
  font-size: 20px;
  font-weight: 500;
  float: left;
  line-height: 24.38px;
}
.heading h5 span {
  color: #a95eea;
}
.heading i {
  cursor: pointer;
  float: right;
  font-size: 20px;
  color: #949494;
  line-height: 24.38px;
}
.heading i:hover {
  color: red;
}
.footer h6 {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
.footer .buttons {
  float: right;
}
.footer .buttons button {
  padding: 9px 24px;
}
.footer .buttons .btn-link {
  text-decoration: none;
  color: #652f8f;
}
.footer .buttons .btn-link:hover {
  color: #a95eea;
}
.bounce-enter-active {
  animation: bounce-in 0.4s;
}
.bounce-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
    